import { getTkn } from 'utils';

export const NETWORK_FAIL_MSG = 'There is a network error: Please contact a Master before continuing';

function addBearerToken(apiConfig, key) {
  return {
    ...apiConfig,
    headers: {
      ...apiConfig.headers,
      Authorization: `Bearer ${getTkn(key)}`,
      // Authorization: 'Basic bWthUGl3aGhmNHZIOUdhOXJtRFNQVlBhNzV1S043aHY6V2U4OXVOdGRMWUpjMjV2Zw==',
      // Authorization: 'Bearer n0JGD9YlPyVMW2X7n5bf9SOeLGKV',
    },
  }
}

export class ApiError extends Error {
  constructor(statusCode, statusText, responseData, ...params) {
    super(...params);

    this.apiStatusCode = `${statusCode}`;
    this.apiStatusText = statusText;
    this.apiResponseData = responseData;
  }
}

/* istanbul ignore next */ 
export const createApi = api => method => async ({
  url,
  apiConfig = {},
  data,
  withAuth,
  key = 'apiKey',
}) => {
  try {
    const config = withAuth ? addBearerToken(apiConfig, key) : { ...apiConfig };
    const response = await api[method](
      url,
      data || config,
      data ? config : undefined,
    );
    return response.data;
  } catch (error) {
    const { response } = error;
    if (response) {
      throw new ApiError(
        response.status,
        response.statusText,
        response.data,
        error,
      );
    } else {
      throw new Error(NETWORK_FAIL_MSG);
    }
  }
};
